import {
  Dialog,
  DialogContent,
  makeStyles,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useDispatch, useSelector } from "react-redux";
import { getPracticasPorAgendaExternos } from "../../../actions/turnos/agenda";
import { FormatoImpresionTicket } from "./FormatoImpresionTicket";

const useStyles = makeStyles((theme) => ({
  background: {
    backgroundColor: theme.palette.grey[50],
  },
  title: {
    color: theme.palette.primary.main,
  },
}));

export const ImpresionTicketOsocna = (props) => {
  const { infoImpresion, open, onClose, idObraSocial } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const { practicas } = useSelector((state) => state.agenda);

  const handleClose = () => {
    onClose();
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
            @page {
                margin: 20px;
            }
        `,
  });

  const handlePrintRow = () => {
    handlePrint();
    onClose();
  };

  useEffect(() => {
    dispatch(getPracticasPorAgendaExternos(props?.infoImpresion?.idAgenda, idObraSocial));
  }, [dispatch]);

  console.log(practicas)
  return (
    <>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <DialogContent className={classes.background}>
          <FormatoImpresionTicket
            practicas={practicas}
            item={infoImpresion}
            handleClose={handleClose}
            handlePrintRow={handlePrintRow}
            componentRef={componentRef}
            modal
          />
        </DialogContent>
      </Dialog>
    </>
  );
};
